import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import clsx from 'clsx';

type BreadcrumbProps = {
  className?: string;
  children: ReactNode;
};

function Breadcrumb({ className, children }: BreadcrumbProps): ReactElement {
  return (
    <nav
      aria-label="breadcrumb"
      className={clsx({
        'main-layout-subtitle': true, // Breadcrumbs occupy the same space as a subtitle, but are not a semantic H2.
        className
      })}
      style={{ marginBottom: '-12px' }} // Ensure that page header bottom border is consistent with subtitle variation.
    >
      <ol className="breadcrumb">{children}</ol>
    </nav>
  );
}

type ItemProps = {
  href?: string;
  active?: boolean;
  className?: string;
  children: ReactNode;
};

function Item({ href, active, className, children }: ItemProps): ReactElement {
  return (
    <li
      className={clsx({
        'breadcrumb-item': true,
        active: active ?? false,
        className
      })}
      {...(active ? { 'aria-current': 'page' } : {})}
    >
      {active ? <>{children}</> : <a href={href}>{children}</a>}
    </li>
  );
}

export default Object.assign(Breadcrumb, {
  Item
});
